import { Injectable } from '@angular/core';

import {
  IDeletePayload,
  IGetPayload,
  IParqServiceRepository,
  IPatchPayload,
  IPostPayload,
} from './models';
import { environment } from '../../../../environments/environment';
import { ParqService } from './parq.service';
import { HttpClient } from '@angular/common/http';
import { LocalAuthService } from '../auth';

@Injectable({ providedIn: 'root' })
export class PaymentsApiService implements IParqServiceRepository {
  private readonly _parqService: ParqService = new ParqService(
    this.http,
    this.localAuthService,
  );

  constructor(
    private readonly http: HttpClient,
    private readonly localAuthService: LocalAuthService,
  ) {
    this.onInit();
  }

  private onInit(): void {
    const baseURL: string = environment.microliths.payments;
    const localBaseURL: string = 'http://localhost:9005/api/payments/v2';

    this._parqService.setAttributes({ baseURL, localBaseURL });
  }

  delete<R = any>(payload: IDeletePayload): Promise<R> {
    return this._parqService.delete(payload);
  }

  get<R = any>(payload: IGetPayload): Promise<R> {
    return this._parqService.get(payload);
  }

  patch<R = any, P = any>(payload: IPatchPayload<P>): Promise<R> {
    return this._parqService.patch(payload);
  }

  post<R = any, P = any>(payload: IPostPayload<P>): Promise<R> {
    return this._parqService.post(payload);
  }
}
